import React, { useState } from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
// reactstrap components
import { Container, Row, Col } from "reactstrap";


// core components
// import AuthNavbar from "components/Navbars/AuthNavbar.js";
// import AuthFooter from "components/Footers/AuthFooter.js";

// import HomeNavbar from "components/Navbars/HomeNavbar";
import HomeHeader from "components/Headers/HomeHeader";
import HomeNavbar from "components/Navbars/HomeNavbar";
import PersonalAccountSidebar from 'components/Sidebars/PersonalAccountSidebar';
import WhiteHeader from 'components/Headers/WhiteHeader';


const PersonalAccountLayout = ({ children }) => {




  return (
    <>
      {/*
        <HomeHeader/>
        
      */}
      <WhiteHeader />
      <PersonalAccountSidebar />
      {/*
          <HomeNavbar />
        */}
      <Container>
        <Row>
          <Col lg="3">
          </Col>
          <Col lg="9">
          {children}
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default PersonalAccountLayout;
